import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=fa4842b0&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=fa4842b0&prod&scopped=true&lang=css&"
import style1 from "./Player.vue?vue&type=style&index=1&id=fa4842b0&prod&lang=css&"
import style2 from "./Player.vue?vue&type=style&index=2&id=fa4842b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports